export default __webpack_public_path__ + "static/media/banner.9ada87ce.webp";